import { createContext, useContext, useEffect, useState } from 'react';
import { AccessToken } from '@web-shared/services/access-token';
import { User } from '@web-shared/types/User.types';

import { checkUser } from '../../api/auth';
import { getUserCompanies } from '../../redux/actions/userCompanies';
import { useAppDispatch } from '../../redux/types';

interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

export const AuthContext = createContext<AuthContextType>({ user: null, setUser: () => null });

export const useAuthContext = () => useContext(AuthContext);

export const useInitAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [finished, setFinished] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const accessToken = AccessToken.getToken();
    if (!accessToken) {
      setFinished(true);
    } else {
      checkUser().then((value) => {
        setUser(value);
        dispatch(getUserCompanies());
        setFinished(true);

      }).catch(() => {
        setUser(null);
        setFinished(true);
      });
    }

  }, []);

  return { user, setUser, finished };
};

